import * as React from 'react'

import { PrivacyView } from './Privacy.view'

export const Privacy = () => {
  return <PrivacyView />
}
